// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_htF","cls2":"SearchBox-cls2_cLr SearchBox-cls1_htF"};